import { APP_CONFIG } from '../config/runtime-config';
const DEBUG_PREFIX = "[AUTH-CONFIG]";
const AUTH_CLIENT_ID = APP_CONFIG.AUTH_CLIENT_ID;
const AUTH_SCOPE = APP_CONFIG.AUTH_SCOPE;
const AUTH_TENANT_ID = APP_CONFIG.AUTH_TENANT_ID;
// Use tenant-specific authority if available, fallback to 'common'
const authority = AUTH_TENANT_ID && AUTH_TENANT_ID !== "common"
    ? `https://login.microsoftonline.com/${AUTH_TENANT_ID}`
    : 'https://login.microsoftonline.com/common';
// Use || instead of ?? so empty string also triggers fallback
const scopes = AUTH_SCOPE || undefined;
if (!AUTH_CLIENT_ID) {
    console.error(DEBUG_PREFIX, "REACT_APP_AUTH_CLIENT_ID is not set! Authentication will fail.");
}
if (!scopes) {
    console.warn(DEBUG_PREFIX, "REACT_APP_AUTH_SCOPE is empty — using default scopes. This may cause token issues.");
}
if (!APP_CONFIG.AUTH_REDIRECT_URI) {
    console.warn(DEBUG_PREFIX, "REACT_APP_AUTH_REDIRECT_URI is empty — falling back to '/ms-redirect'. Set it in Azure App Settings to avoid issues.");
}
export const msalConfig = {
    auth: {
        clientId: AUTH_CLIENT_ID || '',
        authority,
        redirectUri: APP_CONFIG.AUTH_REDIRECT_URI || '/ms-redirect',
        postLogoutRedirectUri: APP_CONFIG.AUTH_LOGOUT_REDIRECT_URI || '/'
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true
    }
};
export const loginRequest = {
    scopes: scopes ? [scopes] : ["User.Read", "openid", "profile", "offline_access"]
};
